module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.person')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('person-form', {
    attrs: {
      "person": _vm.person
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c96a8840!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/person/PersonDetails.vue
// module id = 1030
// module chunks = 2